import { FC } from 'react'

import clsx from 'clsx'

import {
  List as DumbList,
  ListDirection,
  ListSpacing,
} from '@tribeplatform/react-ui-kit/Layout'

type ListProps = {
  padding?: boolean
  spacing?: ListSpacing
  divider?: boolean
  direction?: ListDirection
}

export const List: FC<ListProps> = ({
  padding = false,
  spacing = 'md',
  divider = false,
  direction = 'vertical',
  children,
}) => {
  if (!children) return null
  return (
    <DumbList
      className={clsx([
        padding &&
          direction === 'vertical' && [
            spacing === 'none' && 'py-0',
            spacing === 'sm' && 'py-1.5',
            spacing === 'md' && 'py-2.5',
            spacing === 'lg' && 'py-4',
          ],
        padding &&
          direction === 'horizontal' && [
            spacing === 'none' && 'px-0',
            spacing === 'sm' && 'px-1.5',
            spacing === 'md' && 'px-2.5',
            spacing === 'lg' && 'px-4',
          ],
      ])}
      spacing={spacing}
      divider={divider}
      direction={direction}
    >
      {React.Children.map(children, child => (
        <DumbList.Item>{child}</DumbList.Item>
      ))}
    </DumbList>
  )
}
